import { Work } from "./Work";

export function Experience({ resume }) {

    return (
        <section className="section-card section-card--experience" id="experience">
            <div className="section-card__header">
                <p className="section-card__eyebrow">Career snapshot</p>
            </div>
            <Work resume={resume} />
        </section>
    );
}